/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-11-24
 * @brief EHP 설비수명 - 수명인자 개발
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
//utils
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import { useTrans } from "../../../utils/langs/useTrans";
/**
* @brief EHP 설비수명  - 수명인자 Tree 컴포넌트, 반응형 동작
* @param -
* @returns react components
*/
function DeviceLifeTree(props) {
    //trans
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    // props
    const isMobile = props.isMobile;
    const selTree = props.selTree;
    const setParentCurTree = props.setSelTree;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    //화면 이동
    const navigate = useNavigate();
    //
    const [userTree, setUserTree] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [treeSearchText, setTreeSearchText] = useState("");
    //
    //clog("IN ADMIN TREE : ADMINTREE : " + adminType + " : " + tabType);
    //
    const { data: resInfo, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/usertree?search=${treeSearchText}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: adminType + selTree.reload + treeSearchText
    });
    useEffect(() => {
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, resInfo);
        //clog("IN TREE : RESLT CHECK : " + ERR_URL + " : " + isLoading + " : " + JSON.stringify(resInfo));
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (resInfo /* !isLoading */) {
            if (resInfo.codeNum == CONST.API_200) {
                setUserTree(resInfo.body);
                setParentCurTree(adminType, Object.assign(Object.assign({}, selTree), { reload: false }));
            }
        }
    }, [resInfo, adminType]);
    function onClickSearch(e) {
        setTreeSearchText(searchText);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__left" },
            React.createElement("div", { className: "lnb__top" },
                React.createElement("div", { className: "box__search" },
                    React.createElement("input", { type: "text", placeholder: t("MESSAGE.T1입력하세요", [t("MESSAGE.회사명")]), value: searchText, onChange: (e) => setSearchText(e.target.value) }),
                    React.createElement("button", { type: "button", className: "btn btn-search", onClick: (e) => onClickSearch(e) },
                        React.createElement("span", { className: "hide" }, "\uC870\uD68C")))),
            (userTree.length > 0)
                ? React.createElement("div", { className: "lnb" },
                    React.createElement("ul", { className: "lnb-depth1" }, userTree.map((company, idx) => (React.createElement(ZoneTree, { key: `comp_${idx.toString()}`, company: company, zone: company.zone, selTree: props.selTree, setSelTree: props.setSelTree, adminType: props.adminType, setAdminType: props.setAdminType })))))
                : React.createElement("div", { className: "lnb nodata" },
                    React.createElement("div", { className: "nodata_txt" }, "\uAC80\uC0C9\uACB0\uACFC\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.")))));
}
;
export default DeviceLifeTree;
function ZoneTree(props) {
    //const company = props.company;
    //const zoneTree = (props.company.hasOwnProperty("zone"))?props.company.zone:[];
    const zoneTree = props.zone;
    const selTree = props.selTree;
    const setParentCurTree = props.setSelTree;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    function onClickZone(e, zone) {
        e.stopPropagation();
        setParentCurTree("LIFE", Object.assign(Object.assign({}, selTree), { company: { "companyId": props.company.companyId, "companyName": props.company.companyName, }, zone: { "zoneId": zone.zoneId, "zoneName": zone.zoneName }, reload: false }));
    }
    return (React.createElement(React.Fragment, null, (zoneTree) && zoneTree.map((zone, idx) => (React.createElement("li", { key: "zone_" + idx.toString(), className: `${((selTree) && ((selTree.zone.zoneId === zone.zoneId))) ? "active" : ""}`, onClick: (e) => { onClickZone(e, zone); }, "data-val": "LIFE" },
        React.createElement("p", null,
            React.createElement("a", { href: "#" },
                React.createElement("span", null, props.company.companyName),
                React.createElement("span", null, zone.zoneName))),
        React.createElement("ul", { className: "lnb-depth2" }, React.createElement(SubZoneTree, { key: `zone_${idx.toString()}`, tabType: props.tabType, company: props.company, zone: zone, subZone: zone.subZone, selTree: props.selTree, setSelTree: props.setSelTree, adminType: props.adminType, setAdminType: props.setAdminType })))))));
}
function SubZoneTree(props) {
    const subZoneTree = props.subZone;
    const selTree = props.selTree;
    const setParentCurTree = props.setSelTree;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    //
    function onClickSubZone(e, subZone) {
        e.stopPropagation();
        var actTag = (e.target.tagName === "A") ? e.currentTarget : e.target;
        setParentCurTree("LIFE", Object.assign(Object.assign({}, selTree), { subZone: { "subZoneId": subZone.subZoneId, "subZoneName": subZone.subZoneName }, reload: false }));
    }
    return (React.createElement(React.Fragment, null, (subZoneTree) && subZoneTree.map((subZone, idx) => (React.createElement("li", { key: "subzone_" + idx.toString(), className: `${((selTree) && (selTree.subZone.subZoneId === subZone.subZoneId)) ? "active" : ""}`, onClick: (e) => { onClickSubZone(e, subZone); }, "data-val": "LIFE" },
        React.createElement("a", { href: "#" }, subZone.subZoneName),
        React.createElement("ul", { className: "lnb-depth3", style: { "display": `${((selTree) && (selTree.subZone.subZoneId === subZone.subZoneId)) ? "block" : "none"}` } }, React.createElement(RoomTree, { key: `szone_${idx.toString()}`, tabType: props.tabType, company: props.company, zone: props.zone, subZone: props.subZone, room: subZone.room, selTree: props.selTree, setSelTree: props.setSelTree, isMobile: props.isMobile, adminType: props.adminType, workMode: props.workMode, setWorkMode: props.setWorkMode, setAdminType: props.setAdminType, setCurTabMenu: props.setCurTabMenu })))))));
}
function RoomTree(props) {
    const roomTree = props.room;
    const selTree = props.selTree;
    const setParentCurTree = props.setSelTree;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    function onClickRoom(e, room) {
        e.stopPropagation();
        var actTag = (e.target.tagName === "A") ? e.currentTarget : e.target;
        setParentCurTree("LIFE", Object.assign(Object.assign({}, selTree), { room: { "roomId": room.roomId, "roomName": room.roomName }, reload: true }));
    }
    return (React.createElement(React.Fragment, null, (roomTree) && roomTree.map((room, idx) => (React.createElement("li", { key: "room_" + idx.toString(), className: `${((selTree) && (selTree.room.roomId === room.roomId)) ? "active" : ""}`, onClick: (e) => { onClickRoom(e, room); }, "data-val": "LIFE" },
        React.createElement("a", { href: "#" },
            React.createElement("span", null, room.roomName)))))));
}
